<app-modal [dismissible]="false" class="tool-ticket-report-modal">
  <div class="modal-header" modal-header>
    <h5 class="modal-title">{{ 'tool-ticket-report-modal.title' | translate }}</h5>
  </div>

  <div class="modal-body" modal-body>
    <form [formGroup]="reportForm">

        <app-textarea
            [formControl]="reportForm.controls['description']"
            formControlName="description"
            [required]="true"
            [maxLength]="300"
            [showErrors]="showValidations"
            [label]="'tool-ticket-report-modal.description.label' | translate"
            [placeholder]="'tool-ticket-report-modal.description.placeholder' | translate">
        </app-textarea>

        <div class="switch-row">
            <app-input-switch
                formControlName="affectsProduction"
                topLabel="{{ 'tool-ticket-report-modal.affectsProduction.label' | translate }}"
                [onLabel]="'tool-ticket-report-modal.switch.on' | translate"
                [offLabel]="'tool-ticket-report-modal.switch.off' | translate">
            </app-input-switch>

            <app-input-switch
                formControlName="criticalDeviation"
                topLabel="{{ 'tool-ticket-report-modal.criticalDeviation.label' | translate }}"
                [onLabel]="'tool-ticket-report-modal.switch.on' | translate"
                [offLabel]="'tool-ticket-report-modal.switch.off' | translate">
            </app-input-switch>
        </div>

        <app-input-datepicker
            formControlName="neededBackDate"
            [formControl]="reportForm.controls['neededBackDate']"
            label="{{ 'tool-ticket-report-modal.neededBackDate.label' | translate }}"
            labelAlign="top"
            [placeholder]="'tool-ticket-report-modal.neededBackDate.placeholder' | translate"
            [showErrors]="showValidations && reportForm.controls['neededBackDate'].invalid"
            [showTime]="true"
            hourFormat="24"
            appendTo='body'>
        </app-input-datepicker>

        <app-file-input
            #fileInput
            [acceptedTypes]="'image/*'"
            [required]="true"
            [hasError]="showValidations"
            (onFileUpload)="selectFiles($event)"
            (onFilesSelected)="selectFiles($event)"
            (onFileRemoved)="selectFiles($event)">
        </app-file-input>

    </form>
  </div>

  <div class="modal-footer" modal-footer>
    <app-button
      type="simple"
      (click)="onCancel()"
      [disabled]="isConfirmationInProgress"
      data-dismiss="modal">
      {{ "generic.buttons.close" | translate }}
    </app-button>

    <app-button
      type="primary"
      (clicked)="onConfirm($event)"
      [disabled]="isConfirmationInProgress"
      data-dismiss="modal">
      {{ "generic.buttons.confirm" | translate }}
    </app-button>
  </div>
</app-modal>
